var isArrayLike = function (value) {
    /**
     * isArrayLike([1, 2, 3]) => true
     * isArrayLike(document.body.children) => true
     * isArrayLike('abc') => true
     * isArrayLike(Function) => false
     */
    return value !== null && typeof value !== 'function' && isFinite(value.length);
};
export default isArrayLike;
//# sourceMappingURL=is-array-like.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-array-like.js
// module id = 17
// module chunks = 3